import React from 'react';

const AvailabilityLegend = () => {
  const legendItems = [
    {
      label: 'Available',
      color: 'bg-gradient-to-br from-primary to-secondary',
      textColor: 'text-primary-foreground'
    },
    {
      label: 'Today',
      color: 'ring-2 ring-primary ring-offset-2',
      textColor: 'text-foreground'
    },
    {
      label: 'Unavailable',
      color: 'bg-muted',
      textColor: 'text-muted-foreground'
    },
    {
      label: 'Past Date',
      color: 'opacity-30',
      textColor: 'text-muted-foreground'
    }
  ];

  return (
    <div className="mt-6 md:mt-8 lg:mt-10">
      <h3 className="font-caption font-medium text-sm md:text-base text-foreground mb-3 md:mb-4">
        Availability Legend
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {legendItems?.map((item, index) => (
          <div key={index} className="flex items-center gap-2 md:gap-3">
            <div
              className={`w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl flex items-center justify-center ${item?.color}`}
            >
              <span className={`text-xs md:text-sm font-caption font-medium ${item?.textColor}`}>
                {item?.label === 'Today' ? 'T' : index + 1}
              </span>
            </div>
            <span className="text-xs md:text-sm font-caption text-foreground">
              {item?.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AvailabilityLegend;